import React from 'react';
import { getSurveyUrl } from '../../shared/apiUtils';
import { getEventSlug } from '../../shared/configUtils';
import { getSurveyName } from '../utils';

interface Props {
  survey: any,
}

class SingleSurveyBody extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
  }

  render() {
    let { survey } = this.props;
    return(
      <div className="p3">
        <div className="flexbox-wrapper">
          <div className="flexbox-item-small pthalf pr2 mr2">
            <div className="flexbox-center cs-shadow-thick cs-gradient-blue br5 flexbox-center event-survey-fa-icon-large-wrapper">
              <i className="fas fa-poll-h p1 cs-white event-survey-fa-icon-large" />
            </div>
          </div>
          <div className="flexbox-item fw-b">
            <div className="flexbox-wrapper fs-md fw-sb">
              <div className="cs-live-blue-alt">{survey.surveyable_type} Survey</div>
            </div>
            <div className="fs-xl fw-sb cs-color-black mt1">
              {getSurveyName(survey)}
            </div>
          </div>
        </div>
        <div className="mt56">
          <a className="cs-blue-gradient-btn cs-btn-full cs-new-large-btn" href={getSurveyUrl(survey, getEventSlug())} target="_blank">
            Start Survey
          </a>
        </div>
      </div>
    );
  }

}

export default SingleSurveyBody;
